import React, { useEffect } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtom, useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Sheet } from '@node-space/ui-components'
import { massPayoutStepAtom } from '../atoms/massPayoutAtoms'
import { MassPayoutSteps } from '../types'
import { MassPayoutsUploadApprovals } from './MassPayoutsUploadApprovals'
import { MassPayoutsUploadForm } from './MassPayoutsUploadForm'
import { MassPayoutsUploadSuccess } from './MassPayoutsUploadSuccess'

export interface MassPayoutsUploadProps {
  isOpen: boolean
  onClose: () => void
}

export const MassPayoutsUpload = ({ isOpen, onClose }: MassPayoutsUploadProps) => {
  const { t } = useTranslation()
  const [action, setAction] = useAtom(actionAtom)
  const step = useAtomValue(massPayoutStepAtom)

  const getSheetHeader = (): string => {
    switch (step) {
      case MassPayoutSteps.FORM:
        return t('massPayouts.createNewMassPayout')
      default:
        return ''
    }
  }

  useEffect(() => {
    setAction({
      ...action,
      header: getSheetHeader(),
      onClose: () => {
        action?.onClose()
      },
      meta: {
        ...action?.meta,
      },
    })
  }, [step])

  return (
    <Sheet isOpen={isOpen} header={getSheetHeader()} onClose={onClose}>
      <Box width="full">
        {step === MassPayoutSteps.FORM && <MassPayoutsUploadForm />}
        {step === MassPayoutSteps.SUCCESS && <MassPayoutsUploadSuccess />}
        {step === MassPayoutSteps.APPROVAL && <MassPayoutsUploadApprovals />}
      </Box>
    </Sheet>
  )
}
